module.exports = __webpack_public_path__ + "img/workPermit2.92ab14b9.png";